import { Controller } from '@hotwired/stimulus';
import TomSelect from "tom-select";

export default class extends Controller {
    connect() {
        const config = {
            create: false,
            plugins: ['clear_button'],
            sortField: {
                field: "text",
                direction: "asc"
            }
        };

        new TomSelect(`#${this.element.id}`, config);
    }
}
